import React, { useState } from 'react';
import { AiOutlineMail } from "react-icons/ai";
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import db from './../firebase.js';
import { CgSmile } from "react-icons/cg";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    message: '',
    gelRemoval: [],
    nailRepair: [],
    extensions: [],
    manicureService: '',
    budget: '',
    manicureDesign: '',
    availability: '',
  });

  const [messageSent, setMessageSent] = useState(false);

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    if (type === 'checkbox') {
      setFormData((prevFormData) => {
        const updatedValues = checked
          ? [...prevFormData[name], value]
          : prevFormData[name].filter((val) => val !== value);
        return {
          ...prevFormData,
          [name]: updatedValues
        };
      });
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value
      }));
    }
  };

  const handleSubmit = async (event, formData) => {
    event.preventDefault();

    try {
      const collectionRef = collection(db, 'clients');
      await addDoc(collectionRef, {
        ...formData,
        timestamp: serverTimestamp(),
      });
      setMessageSent(true);
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  return (
    <section className="contact-form container mt-1">
      <h3>
        <AiOutlineMail className="icons" /> Contact
      </h3>
      <hr className='line' />
      <br />
      {messageSent ? (
        <p>
          Your message has been sent! I appreciate your patience and will get back to you as soon as possible. <CgSmile className='icons' />
        </p>
      ) : (
      <form onSubmit={(event) => handleSubmit(event, formData)}>
        <div className="mb-3">
          <input
            className="form-control"
            placeholder="Name"
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <input
            className="form-control"
            placeholder="Email Address"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <input
            className="form-control"
            placeholder="Phone Number (optional)"
            type="text"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3 checkbox-group">
          <h6>Do you need gel or extension removal?</h6>
          <label><input type="checkbox" name="gelRemoval" value="Soak Off Gel Removal (Hands)" onChange={handleChange}/> Soak Off Gel Removal (Hands)</label>
          <label><input type="checkbox" name="gelRemoval" value="Overlay/Extension Removal" onChange={handleChange}/> Overlay/Extension Removal</label>
          <label><input type="checkbox" name="gelRemoval" value="Hard Gel Overlay/Extension Removal" onChange={handleChange}/> Hard Gel Overlay/Extension Removal</label>
          <label><input type="checkbox" name="gelRemoval" value="None" onChange={handleChange}/> None</label>
        </div>

        <div className="mb-3 checkbox-group">
          <h6>Do you have any broken/cracked nails?</h6>
          <label><input type="checkbox" name="nailRepair" value="1-2 Nails" onChange={handleChange}/> 1-2 Nails</label>
          <label><input type="checkbox" name="nailRepair" value="3-4 Nails" onChange={handleChange}/> 3-4 Nails</label>
          <label><input type="checkbox" name="nailRepair" value="5-7 Nails" onChange={handleChange}/> 5-7 Nails</label>
          <label><input type="checkbox" name="nailRepair" value="8-10 Nails" onChange={handleChange}/> 8-10 Nails</label>
          <label><input type="checkbox" name="nailRepair" value="None" onChange={handleChange}/> None</label>
        </div>

        <div className="mb-3 checkbox-group">
          <h6>Do you need extensions or extension refills?</h6>
          <label><input type="checkbox" name="extensions" value="Hard Gel Extensions" onChange={handleChange}/> Hard Gel Extensions</label>
          <label><input type="checkbox" name="extensions" value="Aprés Extensions (Soft Gel/No Refill)" onChange={handleChange}/> Aprés Extensions (Soft Gel/No Refill)</label>
          <label><input type="checkbox" name="extensions" value="Hard Gel Refills" onChange={handleChange}/> Hard Gel Refills</label>
          <label><input type="checkbox" name="extensions" value="None" onChange={handleChange}/> None</label>
        </div>

        <div className="mb-3 radio-group">
          <h6>Please select which service you would like:</h6>
          <label><input type="radio" name="manicureService" value="Tubby Overlay" onChange={handleChange}/> Tubby Overlay </label>
          <label><input type="radio" name="manicureService" value="Tubby Gel Mani" onChange={handleChange}/> Tubby Gel Mani</label>
          <label><input type="radio" name="manicureService" value="Gel Extensions" onChange={handleChange}/> Gel Extensions</label>
          <label><input type="radio" name="manicureService" value="Custom Art" onChange={handleChange}/> Custom Art</label>
          <label><input type="radio" name="manicureService" value="None" onChange={handleChange}/> None</label>
        </div>

        <div className="mb-3 checkbox-group">
        <h6>If you selected custom nail art, what is your budget?</h6>
          <input
            type="text"
            className="form-control"
            id="budget"
            name="budget"
            placeholder="e.g., $125-$200"
            value={formData.budget}
            onChange={handleChange}
          />
      </div>

        <div className="mb-3 radio-group">
          <h6>Would you like to do a solid color or add any designs?</h6>
          <label><input type="radio" name="manicureDesign" value="Solid Color" onChange={handleChange}/> Solid Color</label>
          <label><input type="radio" name="manicureDesign" value="Simple Art (ex. Accent Nail Art, French Mani, Very Simple Art)" onChange={handleChange}/> Simple Art (ex. Accent Nail Art, French Mani)</label>
          <label><input type="radio" name="manicureDesign" value="Moderate Art (ex. 3-5 fingers of Intricate Art, 10 fingers of Moderate Art)" onChange={handleChange}/> Moderate Art </label>
          <label><input type="radio" name="manicureDesign" value="Intricate Art (ex. 10 fingers of Intricate Art)" onChange={handleChange}/> Intricate Art</label>
        </div>


        <div className="mb-3">
          <textarea
            className="form-control"
            placeholder="Your availability: Month/Day/Time"
            name="availability"
            value={formData.availability}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <textarea
            className="form-control"
            placeholder="Questions, comments, concerns...?"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </div>
        <button 
          type="submit" 
          className="btn btn-info submit"
        >
          SUBMIT
        </button>
      </form>
      )}
    </section>
  );
};

export default ContactForm;
